module.exports = __webpack_public_path__ + "static/media/selectedText.ff8a45a2.png";